import { c as _c } from "react/compiler-runtime";
import type { MatchStateClient } from '@svs/nova-poolbetting/schema/sport';
import { cn } from '@svs/nova-poolbetting/ui/utils';
import type { ReactNode } from 'react';
type SportinfoModalMatchStatusProps = {
  matchStatusText: string;
  className?: string;
  matchResultState?: MatchStateClient;
};

/**
 * Component to render match status.
 *
 * @param root0 props for match status
 * @param root0.matchStatusText match status text to display
 * @param root0.className optional class name for styling
 * @param root0.matchResultState match result state to determine text color
 * @returns Component for MatchStatus
 */
export function SportinfoModalMatchStatus(t0) {
  const $ = _c(6);
  const {
    matchStatusText,
    className,
    matchResultState
  } = t0;
  const t1 = matchResultState === "Live" ? "text-tertiary-variant-fg" : "text-layer-fg-muted";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn(t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== matchStatusText || $[4] !== t2) {
    t3 = <div className={t2}>{matchStatusText}</div>;
    $[3] = matchStatusText;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}